<template>
  <div class="chart_box" v-loading="loading">
    <div class="graph_controls">
      <button @click="fullScreen" v-if="!isFullScreen" class="btn_control">
        <i class="iconfont icon-quanping" />
      </button>
      <button @click="exitFullScreen" v-else class="btn_control">
        <i class="iconfont icon-suohui" />
      </button>
      <button @click="zoomLarge" class="btn_control">
        <i class="iconfont icon-fangda" />
      </button>
      <button @click="zoomSmall" class="btn_control">
        <i class="iconfont icon-suoxiao" />
      </button>
      <button @click="resetZoom" class="btn_control">
        <i class="iconfont icon-huanyuan" />
      </button>
    </div>
    <div
      class="chart_box"
      :style="{
        transform: `scale(${scaleLevel})`,
        transformOrigin: 'center center',
        transition: 'transform 0.3s ease',
      }"
    >
      <div ref="chartCon" style="width: 100%; height: 100%"></div>
      <div class="chart_box_menu">
        <OverflowTooltip :tip="companyName" :lineClamp="2" />
      </div>
      <div class="chart_box_menu top" @click="linkToDetail(2)">
        {{ $t("Relationship.Ownership") }} ({{ holdingCompanyData.num }})
      </div>
      <div
        class="chart_box_menu right not_link"
        v-if="importerChainFlag == 0 && supplierChainFlag == 0"
      >
        {{ $t("Relationship.PossibleClients") }} ({{ suspectedBuyersData.num }})
      </div>
      <div v-else class="chart_box_menu right" @click="linkToDetail(6)">
        {{ $t("Relationship.PossibleClients") }} ({{ suspectedBuyersData.num }})
      </div>
      <div class="chart_box_menu bottom" @click="linkToDetail(3)">
        {{ $t("Relationship.Investments") }} ({{ accusedShareholderData.num }})
      </div>
      <div
        class="chart_box_menu left not_link"
        v-if="importerChainFlag == 0 && supplierChainFlag == 0"
      >
        {{ $t("Relationship.PossibleVendors") }} ({{
          suspectedSuppliersData.num
        }})
      </div>
      <div v-else class="chart_box_menu left" @click="linkToDetail(6)">
        {{ $t("Relationship.PossibleVendors") }} ({{
          suspectedSuppliersData.num
        }})
      </div>
    </div>
  </div>
</template>

<script>
import { mixins1 } from "@/mixins/index";
import { getRelationChart } from "@/api/uboApi.js";
export default {
  mixins: [mixins1],
  name: "",
  props: {
    companyName: {
      type: String,
      default: "",
    },
    echartsData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      myChart: null,
      isFullScreen: false,
      scaleLevel: 1,
      minScale: 0.5,
      maxScale: 2.5,
      scaleStep: 0.2,
      zoom: 1,
      dWidth: 200,
      imgCache: {},
      holdingCompanyData: {
        num: 0,
        name: "",
        children: [],
      },
      suspectedBuyersData: {
        num: 0,
        name: "",
        children: [],
      },
      accusedShareholderData: {
        num: 0,
        name: "",
        children: [],
      },
      suspectedSuppliersData: {
        num: 0,
        name: "",
        children: [],
      },
      importerChainFlag: 0,
      supplierChainFlag: 0,
    };
  },
  computed: {
    isSmall() {
      return this.$screen.isSmallScreen;
    },
  },

  watch: {
    echartsData: {
      handler(val) {
        if (val) {
          this.initEcharts();
        }
      },
      deep: true,
    },
    isSmall() {
      this.$nextTick(() => {
        this.resizeChart();
      });
    },
  },
  mounted() {
    // this.$nextTick(() => {

    //     this.initEcharts();

    // });
    this.loading = true;
    getRelationChart({ aaaid: this.$route.query.id3a }).then((res) => {
      // 预加载所有需要的国家图片
      const allCountryCodes = new Set();
      [
        ...(res.data?.holdingCompany || []),
        ...(res.data?.suspectedBuyers || []),
        ...(res.data?.accusedShareholder || []),
        ...(res.data?.suspectedSuppliers || []),
      ].forEach((item) => allCountryCodes.add(item.countryCode));

      allCountryCodes.forEach((code) => {
        try {
          this.imgCache[code] = require(`../../../static${this.getCountryImgUrl(
            code,
          )}`);
        } catch (e) {
          console.warn(`Image not found for ${code}`);
        }
      });
      this.importerChainFlag = res.data?.importerChainFlag;
      this.supplierChainFlag = res.data?.supplierChainFlag;
      this.holdingCompanyData.num = res.data?.holdingCompanyCount || 0;
      this.holdingCompanyData.children =
        res.data?.holdingCompany.map((item) => {
          return {
            name: item.companyName,
            aaaId: item.aaaid,
            countryCode: item.countryCode,
          };
        }) || [];
      this.suspectedBuyersData.num = res.data?.suspectedBuyersCount || 0;
      this.suspectedBuyersData.children =
        res.data?.suspectedBuyers.map((item) => {
          return {
            name: item.companyName,
            aaaId: item.aaaid,
            countryCode: item.countryCode,
          };
        }) || [];
      this.accusedShareholderData.num = res.data?.accusedShareholderCount || 0;

      this.accusedShareholderData.children =
        res.data?.accusedShareholder.map((item) => {
          return {
            name: item.companyName,
            aaaId: item.aaaid,
            countryCode: item.countryCode,
          };
        }) || [];
      this.suspectedSuppliersData.num =
        res.data?.suspectedSupplierpliersCount || 0;

      this.suspectedSuppliersData.children =
        res.data?.suspectedSuppliers.map((item) => {
          return {
            name: item.companyName,
            aaaId: item.aaaid,
            countryCode: item.countryCode,
          };
        }) || [];
      this.initEcharts();
      this.loading = false;
    });

    window.addEventListener("resize", this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
  },
  methods: {
    // 生成动态 rich 对象，根据树形数据生成每个节点的图片映射
    generateRichMap(data) {
      const richMap = {};
      const traverse = (node) => {
        if (node.countryCode) {
          const img = this.imgCache[node.countryCode];
          if (img) {
            richMap[`img_${node.countryCode}`] = {
              backgroundColor: {
                image: img,
              },
              width: 26,
              height: 16,
            };
          }
        }
        if (node.children && node.children.length > 0) {
          node.children.forEach((child) => traverse(child));
        }
      };
      traverse(data);
      return richMap;
    },
    initEcharts() {
      if (!this.myChart) {
        this.myChart = this.$echarts.init(this.$refs.chartCon, null, {
          renderer: "svg",
        });
      }
      // 生成各个数据集的 rich 映射
      const holdingCompanyRich = this.generateRichMap(this.holdingCompanyData);
      const suspectedBuyersRich = this.generateRichMap(
        this.suspectedBuyersData,
      );
      const accusedShareholderRich = this.generateRichMap(
        this.accusedShareholderData,
      );
      const suspectedSuppliersRich = this.generateRichMap(
        this.suspectedSuppliersData,
      );

      const option = {
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
        },

        series: [
          {
            type: "tree",
            data: [this.holdingCompanyData],
            left: "25%",
            right: "25%",
            top: "20%",
            bottom: "54%",
            symbol: "emptyCircle",
            orient: "BT",
            expandAndCollapse: false,
            itemStyle: {
              color: "#F56B6B",
              borderColor: "#F56B6B",
            },
            // zoom: this.$screen.ratio,

            label: {
              position: "bottom",
              rotate: 90,
              verticalAlign: "middle",
              align: "right",
              color: "#F56B6B",
              fontFamily: "Arial",
              fontSize: 14,
              overflow: "truncate",
              ellipsis: "...",
              width: this.dWidth,
              formatter: (params) => {
                const hasImg = this.imgCache[params.data.countryCode];
                return `${
                  params.name != null &&
                  hasImg &&
                  params.data.countryCode != "-"
                    ? `{img_${params.data.countryCode}|} `
                    : ""
                }${params.name}`;
              },
              rich: holdingCompanyRich,
            },
            leaves: {
              label: {
                position: "top",
                rotate: 90,
                verticalAlign: "middle",
                align: "left",
              },
            },
            lineStyle: {
              color: "#F56B6B",
              width: 0.8,
            },
            emphasis: {
              // focus: "descendant",
            },
            animationDurationUpdate: 750,
          },
          {
            type: "tree",
            data: [this.suspectedBuyersData],
            left: "60%",
            right: "12%",
            top: "15%",
            bottom: "15%",
            symbol: "emptyCircle",
            orient: "LR",
            expandAndCollapse: false,
            itemStyle: {
              color: "#8E86DD",
              borderColor: "#8E86DD",
            },
            // zoom: this.$screen.ratio,
            label: {
              position: "left",
              verticalAlign: "middle",
              align: "right",
              color: "#8E86DD",
              fontFamily: "Arial",
              fontSize: 14,
              overflow: "truncate",
              ellipsis: "...",
              width: this.dWidth,
              formatter: (params) => {
                const hasImg = this.imgCache[params.data.countryCode];
                return `${
                  params.name != null &&
                  hasImg &&
                  params.data.countryCode != "-"
                    ? `{img_${params.data.countryCode}|} `
                    : ""
                }${params.name}`;
              },
              rich: suspectedBuyersRich,
            },
            leaves: {
              label: {
                position: "right",
                verticalAlign: "middle",
                align: "left",
              },
            },
            lineStyle: {
              color: "#8E86DD",
              width: 0.8,
            },
            emphasis: {
              // focus: "descendant",
            },
            animationDurationUpdate: 750,
          },
          {
            type: "tree",
            data: [this.accusedShareholderData],
            left: "25%",
            right: "25%",
            top: "54%",
            bottom: "20%",
            symbol: "emptyCircle",
            orient: "TB",
            expandAndCollapse: false,
            itemStyle: {
              color: "#016FF6",
              borderColor: "#016FF6",
            },
            // zoom: this.$screen.ratio,
            label: {
              position: "top",
              rotate: 90,
              verticalAlign: "middle",
              align: "left",
              color: "#016FF6",
              fontFamily: "Arial",
              fontSize: 14,
              overflow: "truncate",
              ellipsis: "...",
              width: this.dWidth,
              formatter: (params) => {
                const hasImg = this.imgCache[params.data.countryCode];
                return `${
                  params.name != null &&
                  hasImg &&
                  params.data.countryCode != "-"
                    ? `{img_${params.data.countryCode}|} `
                    : ""
                }${params.name}`;
              },
              rich: accusedShareholderRich,
            },
            leaves: {
              label: {
                position: "bottom",
                rotate: 90,
                verticalAlign: "middle",
                align: "right",
              },
            },
            lineStyle: {
              color: "#016FF6",
              width: 0.8,
            },
            emphasis: {
              // focus: "descendant",
            },
            animationDurationUpdate: 750,
          },
          {
            type: "tree",
            data: [this.suspectedSuppliersData],
            left: "12%",
            right: "60%",
            top: "15%",
            bottom: "15%",
            symbol: "emptyCircle",
            orient: "RL",
            expandAndCollapse: false,
            itemStyle: {
              color: "#3FB92F",
              borderColor: "#3FB92F",
            },
            // zoom: this.$screen.ratio,
            label: {
              position: "right",
              verticalAlign: "middle",
              align: "left",
              color: "#3FB92F",
              fontFamily: "Arial",
              fontSize: 14,
              overflow: "truncate",
              ellipsis: "...",
              width: this.dWidth,
              formatter: (params) => {
                const hasImg = this.imgCache[params.data.countryCode];
                return `${
                  params.name != null &&
                  hasImg &&
                  params.data.countryCode != "-"
                    ? `{img_${params.data.countryCode}|} `
                    : ""
                }${params.name}`;
              },
              rich: suspectedSuppliersRich,
            },
            leaves: {
              label: {
                position: "left",
                verticalAlign: "middle",
                align: "right",
              },
            },
            lineStyle: {
              color: "#3FB92F",
              width: 0.8,
            },
            emphasis: {
              // focus: "descendant",
            },
            animationDurationUpdate: 750,
          },
        ],
      };
      this.myChart.setOption(option);
      this.myChart.on("click", (event) => {
        console.log(33333, event);
        let row = event.data;
        if (row.aaaId.split("").every((char) => char >= "0" && char <= "9")) {
          let routeData = this.$router.resolve({
            path: "/ubo/detail",
            query: {
              id3a: row.aaaId,
              keyword: row.name,
              selectKey: "Company",
            },
          });
          window.open(routeData.href, "_blank");
        }
      });
    },
    resizeChart() {
      // 调用 ECharts 实例的 resize 方法，动态调整图表大小
      console.log(11111111, this.$screen.ratio);
      if (this.myChart) {
        this.myChart.resize();
      }
    },
    // 缩放
    zoomLarge() {
      this.scaleLevel = Math.min(this.scaleLevel + 0.2, this.maxScale);
      this.initEcharts();
    },
    zoomSmall() {
      this.scaleLevel = Math.max(this.scaleLevel - 0.2, this.minScale);
      this.initEcharts();
    },
    resetZoom() {
      this.scaleLevel = 1;
      this.initEcharts();
    },
    // 全屏
    fullScreen() {
      const elem = this.$el;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
      this.isFullScreen = true;
    },
    // 退出全屏
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
      this.isFullScreen = false;
    },
    linkToDetail(type) {
      let routeData = this.$router.resolve({
        path: "/ubo/detail",
        query: {
          id3a: this.$route.query.id3a,
          keyword: this.$route.query.keyword,
          selectKey: this.$route.query.selectKey,
          type: type,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
<style scoped>
.chart_box {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: #f5f5f5;
}
.chart_box_menu {
  position: absolute;
  left: 50%;
  top: 50%;
  right: 50%;
  bottom: 50%;
  transform: translate(-50%, -50%);
  width: 18%;
  height: 6%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #603c2c;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
  font-style: normal;
  cursor: pointer;
}
.chart_box_menu.top {
  transform: translate(-50%, -210%);
  width: 16%;
  height: 4%;
  background: #ffe9e9;
  color: #f56b6b;
  border: 1px solid #f56b6b;
}
.chart_box_menu.right {
  transform: translate(65%, -50%);
  width: 16%;
  height: 4%;
  background: #ebe9ff;
  color: #8e86dd;
  border: 1px solid #8e86dd;
}
.chart_box_menu.bottom {
  transform: translate(-50%, 110%);
  width: 16%;
  height: 4%;
  background: #e2efff;
  color: #016ff6;
  border: 1px solid #016ff6;
}
.chart_box_menu.left {
  transform: translate(-165%, -50%);
  width: 16%;
  height: 4%;
  background: #f2fff0;
  color: #3fb92f;
  border: 1px solid #3fb92f;
}

.graph_controls {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 8;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 40px;
  padding: 20px 0;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.btn_control {
  width: 40px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  background-color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 24px;
  font-weight: 500;
  transition: all 0.3s;
}

.btn_control i {
  font-size: 20px;
}
.btn_control:hover {
  background-color: #f0f0f0;
  border-color: #999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.btn_control:active {
  background-color: #e0e0e0;
}
.not_link {
  cursor: not-allowed;
}
@media (max-width: 1920px) {
  .graph_controls {
    padding: 14px 0;
    gap: 16px;
  }
  .btn_control {
    height: 20px;
    line-height: 16px;
    font-size: 20px;
  }
}
</style>
